import { render, staticRenderFns } from "./UserGeneralForm.vue?vue&type=template&id=f87f2056"
import script from "./UserGeneralForm.vue?vue&type=script&lang=js"
export * from "./UserGeneralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports